
<div fxLayout="row" fxLayoutGap="10px" [formGroup]="grp">

  <mat-form-field fxFlex="60px">
    <mat-label>{{ _multiplyLabel }}</mat-label>
    <input matInput type="number" formControlName="multiply" maxlength="3" autocomplete="off" step="1" (change)="notifyFormChanged()">              
  </mat-form-field>

  <mat-form-field fxFlex="100px">
    <mat-label>Time unit</mat-label>
    <mat-select placeholder="" formControlName="unit" (selectionChange)="notifyFormChanged()">
      <mat-option [value]="TimePeriodUnit.Day">Day</mat-option>
      <mat-option [value]="TimePeriodUnit.Month">Month</mat-option>
      <mat-option [value]="TimePeriodUnit.Year">Year</mat-option>
    </mat-select>
    <mat-error>Required field</mat-error>
  </mat-form-field>

</div>